module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr23-6a225763e5e46dcb66c3f5119220851b.jpg";